import { LOGOUT_PRESS } from '~constants/cpa-message-codes';
export var postLogoutPressMessage = function () {
    var _a;
    (_a = window.ReactNativeWebView) === null || _a === void 0 ? void 0 : _a.postMessage(JSON.stringify({
        code: LOGOUT_PRESS,
    }));
};
